var firebase = require("firebase");

// Initialize Firebase
// TODO: Replace with your project's customized code snippet

//preseli web
// var config = {
//     apiKey: "AIzaSyDxTdAAanCY9GESUa4IuhdM7DPoCZS-2bs",
//     authDomain: "preseli-493c5.firebaseapp.com",
//     databaseURL: "https://preseli-493c5.firebaseio.com",
//     projectId: "preseli-493c5",
//     storageBucket: "preseli-493c5.appspot.com",
//     messagingSenderId: "674039325608"
// };

const config = {
    apiKey: "AIzaSyDK3cSmdQM5YJ45mAYOOoWSQm3Gc0e1WGE",
    authDomain: "admin-playground.firebaseapp.com",
    databaseURL: "https://admin-playground.firebaseio.com",
    projectId: "admin-playground",
    storageBucket: "admin-playground.appspot.com",
    messagingSenderId: "749890938296"
  };

// var file = module.exports = {
function saveContactForm(contactFormDetails, callback) {
    const successMessage = { type: 'success', message: 'Thank you for contacting us, one of our colleague will be in touch with you soon.', submitted: true };
    const failMesssage = { type: 'error', message: 'Sorry there seems to be an error with submitting the form. Please try again later or contact us directly', submitted: false };

    this.contactFormDetails = contactFormDetails;
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    var user = firebase.auth().currentUser;

    if (user) {
        saveFormToDatabase(contactFormDetails, function () {
            callback(successMessage);
        });
    } else {
        //create anonymous user to use firebase db
        firebase.auth().signInAnonymously().catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log('Cannot create anonymous user: ' + errorMessage);
            callback(failMesssage);
        }).then(function () {
            saveFormToDatabase(contactFormDetails).then(function () {
                callback(successMessage);
            });
        });
    }
}
// }

function saveFormToDatabase(contactFormDetails) {
    return firebase.database().ref('contact/' + firebase.auth().currentUser.uid + '/form').push({
        name: contactFormDetails.name,
        email: contactFormDetails.email,
        company: contactFormDetails.company,
        message: contactFormDetails.contactMessage,
        timestamp: firebase.database.ServerValue.TIMESTAMP
    });
}

function readProductFromDatabase(callback) {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    firebase.database().ref('products/').once('value').then(function (snapshot) {
        callback(snapshot.val());
    });
}
//KSG08-25kg~1200kg/hr-(Zone-1)
//KSG08-25kg~1200kg/hr-(Zone-1)
function findProductFromDatabase(code, callback) {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    firebase.database().ref('products/').orderByChild("idCode").equalTo(code).once('value').catch(function (e) {
        console.log(e);
    }).then(function (snapshot) {
        callback(snapshot.val());
    });
}

function getProductImagesFromDatabase(callback) {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    firebase.database().ref('product_images/').once('value').then(function (snapshot) {
        // console.log(snapshot.val)();
        callback(snapshot.val());
    });
}

function findProductImageFromDatabase(id, callback) {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }

    firebase.database().ref('product_images/').orderByChild("id").equalTo(id).once('value').catch(function (e) {
        console.log(e);
    }).then(function (snapshot) {
        callback(snapshot.val());
    });
}

//https://stackoverflow.com/questions/37907106/firebase-how-to-retrieve-data-from-two-tables-using-id
export default { saveContactForm, readProductFromDatabase, findProductFromDatabase, getProductImagesFromDatabase, findProductImageFromDatabase }




// WEBPACK FOOTER //
// ./src/service/FirebaseService.js